import { platform } from 'playcanvas';
import type { Global } from '../../submodules/supersplat-viewer/src/types';
import type { App } from '../../submodules/supersplat-viewer/src/app';

/**
 * 计算画布渲染分辨率，对齐 supersplat-viewer standalone 的 initCanvas 策略：
 * 1) 高 DPI 封顶：按屏幕最短边限制最大像素维度（移动 1080 / 桌面 2160），
 *    再与 devicePixelRatio 取小，避免 Retina 上 4x 像素的填充率开销；
 * 2) performanceMode（移动端默认开启）下按 0.5x 渲染再上采样，填充率降到 1/4。
 */
export function applyCanvasSize(
  canvas: HTMLCanvasElement,
  app: App,
  global: Global,
  width: number,
  height: number,
  initialized: boolean,
  disposed: boolean,
): void {
  if (!initialized || disposed || app.xr?.active) return;
  const maxPixelDim = platform.mobile ? 1080 : 2160;
  const pixelRatio = Math.min(
    maxPixelDim / Math.min(screen.width, screen.height),
    window.devicePixelRatio,
  );
  const scale = global.state.performanceMode ? 0.5 : 1.0;
  canvas.width = Math.max(1, Math.ceil(width * pixelRatio * scale));
  canvas.height = Math.max(1, Math.ceil(height * pixelRatio * scale));
  // 触发下一帧渲染；autoRender=false 下必须显式请求帧
  app.renderNextFrame = true;
}
